if (!customElements.get('scroll-quote-reveal')) {
  customElements.define(
    'scroll-quote-reveal',
    class ScrollQuoteReveal extends HTMLElement {
      constructor() {
        super();
        this.frame = null;
        this.handleUpdate = this.handleUpdate.bind(this);
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      connectedCallback() {
        this.content = this.querySelector('.scroll-quote__content');
        if (!this.content || this.reducedMotion) return;

        this.updateMask();

        window.addEventListener('scroll', this.handleUpdate, { passive: true });
        window.addEventListener('resize', this.handleUpdate);

        if (typeof ResizeObserver !== 'undefined') {
          this.resizeObserver = new ResizeObserver(this.handleUpdate);
          this.resizeObserver.observe(this);
          this.resizeObserver.observe(this.content);
        }
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.handleUpdate);
        window.removeEventListener('resize', this.handleUpdate);

        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
          this.resizeObserver = null;
        }

        if (this.frame) {
          cancelAnimationFrame(this.frame);
          this.frame = null;
        }
      }

      handleUpdate() {
        if (this.frame) return;

        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.updateMask();
        });
      }

      updateMask() {
        if (!this.content) return;

        const rect = this.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
        const enteringFadeDepth = window.innerWidth >= 990
          ? clamp(24 * rootFontSize, viewportHeight * 0.5, 48 * rootFontSize)
          : clamp(16 * rootFontSize, viewportHeight * 0.5, 32 * rootFontSize);
        const exitingFadeDepth = window.innerWidth >= 990
          ? clamp(10 * rootFontSize, viewportHeight * 0.16, 18 * rootFontSize)
          : clamp(8 * rootFontSize, viewportHeight * 0.14, 16 * rootFontSize);

        const topStart = clamp(0, -rect.top, rect.height);
        const topEnd = clamp(topStart, exitingFadeDepth - rect.top, rect.height);
        const bottomStart = clamp(topEnd, viewportHeight - enteringFadeDepth - rect.top, rect.height);
        const bottomEnd = clamp(bottomStart, viewportHeight - rect.top, rect.height);

        this.style.setProperty('--scroll-quote-mask-top-start', `${topStart}px`);
        this.style.setProperty('--scroll-quote-mask-top-end', `${topEnd}px`);
        this.style.setProperty('--scroll-quote-mask-bottom-start', `${bottomStart}px`);
        this.style.setProperty('--scroll-quote-mask-bottom-end', `${bottomEnd}px`);
      }
    }
  );
}

function clamp(min, value, max) {
  return Math.min(Math.max(value, min), max);
}
